import { Icons } from '../constants'

import Login from '../views/admin/Login.vue'

import Categorias from '../components/panel/Categorias.vue'
import ListasDeCorreo from '../components/panel/ListasDeCorreo'
import Mensajes from '../components/panel/Mensajes.vue'
import PanelAdmin from '../views/admin/PanelAdmin.vue'
import PanelBanners from '../components/panel/PanelBanners.vue'
import PanelBeneficios from '../components/panel/PanelBeneficios.vue'
import PanelCodigos from '../components/panel/PanelCodigos.vue'
import PanelComentarios from '../components/panel/PanelComentarios.vue'
import PanelComercios from '../components/panel/PanelComercios.vue'
import PanelConsultas from '../components/panel/PanelConsultas.vue'
import PanelEstadisticas from '../components/panel/PanelEstadisticas.vue'
import PanelSolicitudes from '../components/panel/PanelSolicitudes.vue'
import PanelUsuariosComercio from '../components/panel/PanelUsuariosComercio.vue'
import Personas from '../components/panel/Personas.vue'

export const RouteNames = {
  logIn: "admin.login"
}

export const VistasMenuPanel = [
  {
    // Atributos de ruta
    component: Personas,
    // Como tiene path vacío, es la ruta por defecto
    path: '',
    // Es importante que las vistas tengan un nombre ya que en esto se basa el menú para ir hacia ellas
    name: 'personas',
    // Atributos de vista
    titulo: 'Personas',
    icono: Icons.PERSONA,
  },
  {
    component: PanelBeneficios,
    path: 'beneficios',
    name: 'beneficios',
    titulo: 'Beneficios',
    icono: Icons.BENEFICIO,
  },
  {
    component: PanelComercios,
    path: 'comercios',
    name: 'comercios',
    titulo: 'Comercios',
    icono: Icons.COMERCIO,
  },
  {
    component: PanelCodigos,
    path: 'codigos',
    name: 'codigos',
    titulo: 'Códigos',
    icono: Icons.CODIGO,
  },
  {
    component: Categorias,
    path: 'categorias',
    name: 'categorias',
    titulo: 'Categorias',
    icono: Icons.CATEGORIAS_ADMIN,
  },
  {
    component: PanelBanners,
    path: 'banners',
    name: 'banners',
    titulo: 'Banners',
    icono: Icons.BANNER,
  },
  {
    component: PanelSolicitudes,
    path: 'solicitudes',
    name: 'solicitudes',
    titulo: 'Solicitudes',
    icono: Icons.COMERCIO_SOLICITUD,
  },
  {
    component: PanelUsuariosComercio,
    path: 'usuarioscomercio',
    name: 'usuarioscomercio',
    titulo: 'Usuarios de Comercios',
    icono: Icons.USUARIO_COMERCIO,
  },
  {
    component: Mensajes,
    path: 'mensajes',
    name: 'mensajes',
    titulo: 'Mensajes',
    icono: Icons.CATEGORIAS_ADMIN,
  },
  {
    component: ListasDeCorreo,
    path: 'listascorreo',
    name: 'listascorreo',
    titulo: 'ListasDeCorreo',
    icono: Icons.CATEGORIAS_ADMIN,
  },
  {
    component: PanelComentarios,
    path: 'comentarios',
    name: 'comentarios',
    titulo: 'Comentarios',
    icono: Icons.COMENTARIO,
  },
  {
    component: PanelConsultas,
    path: 'consultas',
    name: 'consultas',
    titulo: 'Consultas',
    icono: Icons.BUSCAR,
  },
  {
    component: PanelEstadisticas,
    path: 'estadisticas',
    name: 'estadisticas',
    titulo: 'Estadísticas',
    icono: Icons.ESTADISITCAS,
  },
]

export const routes = [
  {
    path: '/login',
    name: RouteNames.logIn,
    component: Login,
  },
  {
    path: '/panel',
    component: PanelAdmin,
    meta: {
      autenticado: true,
    },
    children: VistasMenuPanel,
  },
]